<template>
  <privat-auth-blank-form
    submit-label="Отправить"
    :user="user"
    :errors="errors"
    @submit="processAuthForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { privatAuth } from '@/services/privat_auth.service'
import privatAuthBlankForm from '@/components/forms/privat_auth/PrivatAuthBlankForm'

export default {
  name: 'privat-auth-form',
  components: { privatAuthBlankForm },
  data () {
    return {
      user: {
        login: '',
        password: ''
      },

      errors: {
        user: {
          login: [],
          password: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,
    fillNonFieldErrors: helpers.fillNonFieldErrors,

    processAuthForm () {
      this.privatAuth().then((success) => {
        if (success) {
          this.showMsg('Авторизация прошла успешно!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    privatAuth () {
      return privatAuth(this.user).then((response) => {
        this.fillErrors(this.errors.user, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.user, err.response.data)
        console.log(err.response)
        if (err.response.status === 400) {
          this.fillNonFieldErrors(this.errors, err.response.data)
          console.log(this.errors)
          if (this.errors.non_field_errors[0]) {
            this.showMsg(this.errors.non_field_errors[0], 'error', 'Ошибка')
          }
        } else if (err.response.status === 404) {
          this.$router.push({ name: 'privat-otp-auth' })
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// PrivatAuthForm.vue?fc6ea522